var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.relativeFutureStartDate)?_c('el-alert',{staticClass:"top-warning",attrs:{"title":("This " + _vm.name + " goes live in " + _vm.relativeFutureStartDate),"type":"info","show-icon":"","closable":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }